import * as React from 'react';
import {Link, useParams} from 'react-router-dom';
import {useCallback, useEffect, useState} from "react";
import Table from "../../Table";
import {AppUser, Client, ClientDocument, Template} from "../../../types";
import {useHistory} from "react-router";
import {
    addDocumentToClient,
    completeTherapySession, createDocument, deleteClientToTherapySession,
    deleteTherapySession, getClientDocument, getClients, getDocumentKey, getEsignProfiles, getTemplates,
    getTherapySession,
    getUsers, markAttendanceForClientInTherapySession, resetAttendanceForClientInTherapySession,
    updateTherapySessions
} from "../../../api";
import dateFormat from "dateformat";

const dateParse = require('date-format');


const ViewTherapySession: React.FunctionComponent = () => {
    let esignEndpoint = (window.location.protocol + '//' + window.location.hostname);
    if (window.location.hostname === "34.201.190.181") {
        esignEndpoint = "http://34.201.190.181:3005";
    }
    if (window.location.hostname === "localhost") {
        esignEndpoint = "http://localhost:2999";
    }

    if (window.location.hostname === "test.promises12data.com" || window.location.hostname === "promises12data.com") {
        esignEndpoint = "https://esign.promises12data.com";
    }

    const [therapist, setTherapist] = useState("");
    const [date, setDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [status, setStatus] = useState("");
    const [users, setUsers] = useState<AppUser[]>();
    const [clients, setClients] = useState<Client[]>();
    const [doNoteSignRedirect, setDoNoteSignRedirect] = useState(false);
    const history = useHistory();
    const {id} = useParams();
    const [editMode, setEditMode] = useState(false);
    const [doRedirectToSearch, setDoRedirectToSearch] = useState(false);

    const [templates, setTemplates] = useState<Template[]>();
    const [profile, setProfile] = useState("");
    const [note, setNote] = useState("");

    const load = useCallback(() => {
        getTherapySession(id)
            .then((t) => {
                setTherapist(t.therapist.uuid);
                setDate(t.date);
                setStartTime(dateFormat(dateParse.parse("hh:mm", t.startTime), "HH:MM"));
                setEndTime(dateFormat(dateParse.parse("hh:mm", t.endTime), "HH:MM"));
                setStatus(t.status);
                setNote(t.noteUuid || "");
            })
            .catch((e) => console.log(e));

        getClients("", "", "", "", "false", id)
            .then((c) => {
                setClients(c);
            })
            .catch((e) => {
                console.log(e);
            })
        getUsers()
            .then((uz) => {
                setUsers(uz);
            })
            .catch((e) => console.log(e))
            .finally(() => {
            })
        getEsignProfiles()
            .then((ps) => {
                let profile = ps.filter((p) => p.name === "Promises12")[0];
                setProfile(profile.uuid);
                getTemplates(profile.uuid)
                    .then((tz) => {
                        setTemplates(tz.filter((t) => t.tag === "note"));
                    })
            })
            .catch((e) => {
                console.error(e);
            })
    }, [id])

    useEffect(() => {

        load();

    }, [load]);

    useEffect(() => {
        if (doNoteSignRedirect) {
            history.push({
                pathname: "/s/" + note + "/123"
            });
        }
    }, [doNoteSignRedirect, history, note]);


    const doUpdate = () => {
        updateTherapySessions(id, {
            therapist: {
                uuid: therapist
            },
            date: date,
            endTime: endTime,
            startTime: startTime,
            noteUuid: note
        })
            .then((t) => {
                setEditMode(false);
            })
            .catch((e) => console.log(e))
    }

    useEffect(() => {
        if (doRedirectToSearch) {
            history.push({
                pathname: "/m/therapy-sessions"
            });
        }
    }, [doRedirectToSearch, history]);

    const doDelete = () => {
        deleteTherapySession(id)
            .then((t) => {
                if (t.ok) {
                    setDoRedirectToSearch(true);
                }
            })
            .catch((e) => console.log(e))
    }

    const doComplete = () => {
        completeTherapySession(id)
            .then((t) => {
                load();
            })
    }

    const doDeleteClient = (clientId: string) => {
        deleteClientToTherapySession(id, clientId)
            .then((r) => {
                if (r.ok) {
                    load();
                }
            })
    }

    const didAttend = (client: Client, therapySessionId: string) => {
        try {
            return client.attendances.filter((a) => a.therapySession.uuid === therapySessionId)[0].attended
        } catch (e) {
            return false;
        }
    }

    const isSigned = (client: Client, therapySessionId: string) => {
        try {
            return client.attendances.filter((a) => a.therapySession.uuid === therapySessionId)[0].signed
        } catch (e) {
            return false;
        }
    }

    const doNotAttend = (clientId: string) => {
        markAttendanceForClientInTherapySession(id, clientId, false)
            .then((r) => {
                if (r.ok) {
                    load();
                }
            })
    }

    const doAddNote = (c: Client) => {
        if (note !== undefined && note !== "" && profile !== undefined && profile !== "") {

            createDocument(profile, {
                template: {
                    uuid: note
                },
                fields: [{
                    name: "fullName",
                    value: c.firstName + " " + c.lastName
                }, {
                    name: "firstName",
                    value: c.firstName
                }, {
                    name: "lastName",
                    value: c.lastName
                }, {
                    name: "id",
                    value: c.id
                }, {
                    name: "email",
                    value: c.email
                }, {
                    name: "ssn",
                    value: c.socialsecurityNumber
                }, {
                    name: "driversLicenseState",
                    value: c.driverslicenseState
                }, {
                    name: "driversLicenseNumber",
                    value: c.driverslicenseNumber
                }, {
                    name: "dateOfBirth",
                    value: c.dateofBirth
                }, {
                    name: "telephone",
                    value: c.telephoneNumber
                }, {
                    name: "addressLine1",
                    value: c.address.addressLine1
                }, {
                    name: "addressLine2",
                    value: c.address.addressLine2
                }, {
                    name: "city",
                    value: c.address.city
                }, {
                    name: "stateCode",
                    value: c.address.state
                }, {
                    name: "zip",
                    value: c.address.zip
                }, {
                    name: "balance",
                    value: c.balance + ""
                }, {
                    name: "assessmentDate",
                    value: dateFormat(dateParse.parse("yyyy-MM-ddThh:mm:ss", c.dateTimeofAssessment), "yyyy-mm-dd")
                }, {
                    name: "assessmentTime",
                    value: dateFormat(dateParse.parse("yyyy-MM-ddThh:mm:ss", c.dateTimeofAssessment), "HH:MM")
                }, {
                    name: "recommendedHours",
                    value: c.recommendedHours
                }, {
                    name: "totalHoursAttended",
                    value: c.totalHoursAttended
                }, {
                    name: "absences",
                    value: c.absences
                }]
            }).then((d) => {
                const esignUrl = esignEndpoint + '/s/' + profile + "/" + d.uuid;
                getDocumentKey(profile, d.uuid)
                    .then((k) => {
                        addDocumentToClient(c.uuid, {
                            type: "NOTE",
                            name: d.template.name,
                            url: esignUrl,
                            description: "Client form",
                            status: "PENDING"
                        }).then((cd) => {
                            markAttendanceForClientInTherapySession(id, c.uuid, true, cd.uuid)
                                .then((r) => {
                                    if (r.ok) {
                                        load();
                                        const completeDocUrl = (window.location.protocol + '//' + window.location.host) + "/m/clients/" + c.uuid + "/documents/complete/" + cd.uuid;
                                        window.open(esignUrl + "?document_key=" + k.uuid + "&redirect_uri=" + completeDocUrl, '_blank');
                                    }
                                });

                        })
                    })

            })


        }

    }

    const doUndo = (clientId: string) => {

        resetAttendanceForClientInTherapySession(id, clientId)
            .then((r) => {
                if (r.ok) {
                    load();
                }
            })
    }

    const doOpenNote = (c: Client, therapySessionId: string) => {
        let documentId = c.attendances.filter((a) => a.therapySession.uuid === therapySessionId)[0].document.uuid;
        getClientDocument(c.uuid, documentId)
            .then((cd) => {
                const docValues = cd.url.substring(cd.url.indexOf("/s/")).split("/");
                getDocumentKey(profile, docValues[3])
                    .then((k) => {
                        const esignUrl = esignEndpoint + '/s/' + profile + "/" + docValues[3];
                        window.open(esignUrl + "?document_key=" + k.uuid, '_self');
                    })
            })
    }


    return (<>
        <form>
            <div className={"row"}>
                <div className={"col-lg-12 mb-3 "}>
                    <h2>Therapy Session</h2>
                </div>
                <div className={"col-lg-12 mb-3 "} hidden={status === "Completed"}>
                    <button className={"btn btn-sm btn-danger mr-1"}
                            onClick={(e) => {
                                e.preventDefault();
                                doDelete();
                            }}
                    >Delete
                    </button>
                    <button hidden={editMode} className={"btn btn-sm btn-primary mr-1"}
                            onClick={(e) => {
                                e.preventDefault();
                                setEditMode(true);
                            }}
                    >Edit
                    </button>
                    <button hidden={!editMode} className={"btn btn-sm btn-primary mr-1"}
                            onClick={(e) => {
                                e.preventDefault();
                                doUpdate();
                            }}
                    >Save
                    </button>
                    <button className={"btn btn-sm btn-success"}
                            onClick={(e) => {
                                e.preventDefault();
                                doComplete();
                            }}
                    >Complete Session
                    </button>
                </div>

                <div className={"col-lg-12 mb-3 "}>

                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Therapist</label>
                            <select id="inputState" className="form-control" value={therapist} disabled={!editMode}
                                    onChange={(e) => setTherapist(e.target.value)}>
                                <option key={"u_0"}>Select a therapist...</option>
                                {
                                    users?.map((u) => (
                                        <option key={u.uuid} value={u.uuid}>{u.lastName + ", " + u.firstName}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label htmlFor="inputEmail4">Date</label>
                            <input type="date" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={date} onChange={(e) => setDate(e.target.value)}/>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label htmlFor="inputEmail4">Start Time</label>
                            <input type="time" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={startTime}
                                   onChange={(e) => setStartTime(e.target.value)}/>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label htmlFor="inputEmail4">End Time</label>
                            <input type="time" className="form-control" id="inlineFormInputName" disabled={!editMode}
                                   value={endTime}
                                   onChange={(e) => setEndTime(e.target.value)}/>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label htmlFor="inputEmail4">Status</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={true}
                                   value={status}
                            />
                        </div>
                        <div className="col-sm-4 my-1">
                            <label htmlFor="inputEmail4">Session Type</label>
                            <select className="custom-select" id="inputGroupSelect04"
                                    required={true}
                                    disabled={!editMode}
                                    aria-label="Example select with button addon" value={note}
                                    onChange={(e) => setNote(e.target.value)}>
                                <option value={""}>Choose...</option>
                                {
                                    templates?.map((t) => (
                                        <option key={t.uuid} value={t.uuid}>{t.name}</option>
                                    ))
                                }

                            </select>
                        </div>
                    </div>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <h5>Clients</h5>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <Link to={"/m/therapy-sessions/add-client/" + id}>
                        <button hidden={status === "Completed"} className={"btn btn-sm btn-primary"} type={"button"}>Add
                            client to session
                        </button>
                    </Link>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <Table
                        headers={["ID", "First Name", "LastName", "Email", "Total Hours Attended", "Recommended Hours", "Absences", "Note"]}
                        defaultPaginationSize={25}>
                        {
                            clients?.map((c) => (
                                <tr key={c.uuid}>
                                    <td>
                                        <Link to={"/m/clients/view/" + c.uuid}>
                                            {c.id}
                                        </Link>
                                    </td>
                                    <td>{c.firstName}</td>
                                    <td>{c.lastName}</td>
                                    <td>{c.email}</td>
                                    <td>
                                        <Link to={"/m/clients/view/" + c.uuid}>
                                            {c.totalHoursAttended}
                                        </Link>
                                    </td>
                                    <td>{c.recommendedHours}</td>
                                    <td>
                                        <Link to={"/m/clients/view/" + c.uuid}>
                                            {c.absences}
                                        </Link>
                                    </td>
                                    <td>
                                        <div hidden={status === "Completed" || isSigned(c, id)} className="input-group">
                                            <select className="custom-select" id="inputGroupSelect04"
                                                    aria-label="Example select with button addon" value={note}
                                                    onChange={(e) => setNote(e.target.value)}
                                                    disabled={true}
                                            >
                                                <option value={""}>Choose...</option>
                                                {
                                                    templates?.map((t) => (
                                                        <option key={t.uuid} value={t.uuid}>{t.name}</option>
                                                    ))
                                                }

                                            </select>
                                            <div className="input-group-append">

                                                <button disabled={note === ""} className="btn btn-primary btn-sm"
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            doAddNote(c);
                                                        }}
                                                >Add Note
                                                </button>
                                                <button disabled={false} className="btn btn-warning btn-sm"
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            doNotAttend(c.uuid);

                                                        }}>Did not attend
                                                </button>
                                                <button disabled={false} className="btn btn-danger btn-sm" type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            doDeleteClient(c.uuid);
                                                        }}>Remove from session
                                                </button>

                                            </div>
                                        </div>
                                        <div hidden={status === "Completed" || !isSigned(c, id)}
                                             className="input-group">

                                            {(didAttend(c, id)) ?
                                                <button type={"button"} className={"btn btn-sm btn-primary"}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            doOpenNote(c, id);
                                                        }}>View
                                                    Note</button> :
                                                <button type={"button"} disabled={true}
                                                        className={"btn btn-sm btn-secondary"}>Absent</button>
                                            }
                                            <button type={"button"} disabled={false}
                                                    className={"btn btn-sm btn-warning ml-1"}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        doUndo(c.uuid);
                                                    }}>Undo
                                            </button>
                                        </div>
                                        <div hidden={status !== "Completed"}>
                                            {(didAttend(c, id)) ?
                                                <button type={"button"} className={"btn btn-sm btn-primary"}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            doOpenNote(c, id);
                                                        }}>View
                                                    Note</button> :
                                                <button type={"button"} disabled={true}
                                                        className={"btn btn-sm btn-secondary"}>Absent</button>
                                            }
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>

                            ))
                        }
                    </Table>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <Link to={"/m/therapy-sessions"}>
                        <button type={"button"} className={"btn btn-primary mr-3"}>
                            Back
                        </button>
                    </Link>

                </div>

            </div>
        </form>
    </>);
};

export default ViewTherapySession;